import { Link } from "src/router";

/** Where the mapper's columns come from, and how to make more of them available. */
export function CantFindColumnMessage() {
  return (
    <>
      We display the columns and traits available for the audience or parent
      model you're syncing, along with any columns that have been{" "}
      <Link
        href={`${import.meta.env.VITE_DOCS_URL}/customer-studio/schema#merge-columns`}
        isExternal
      >
        merged
      </Link>{" "}
      from related models with 1:1 or many:1 relationships. To access additional
      columns, update your{" "}
      {/* FIXME: linking to the schema for the source would be ideal, but I'm not sure how to get the source ID here. sourceId in the formkit context is unset. */}
      <Link href="/schema-v2" isExternal>
        schema
      </Link>{" "}
      or create a{" "}
      <Link href="/traits" isExternal>
        trait
      </Link>{" "}
      to transform your data.
    </>
  );
}
